import React from 'react'

const Feature = ({url, image, brand}) => (
    <a href={url} target="_blank" rel="noreferrer" className="inline-block">
        <img src={image} className="sm:w-auto mx-auto sm:mb-0 mb-8 w-9/12 " alt={brand} />
    </a>
)

export default Feature